import { request } from '@/services/fetch';

export async function getRecadosNaoVistosContagem(clinicaId) {
  const params = new URLSearchParams();
  params.set('clinicaId', String(clinicaId || ''));
  return request(`api/recados/contagem-nao-vistos?${params.toString()}`, { method: 'GET' });
}

export async function marcarRecadosCaixaVista(clinicaId) {
  return request('api/recados/marcar-caixa-vista', {
    method: 'PATCH',
    body: JSON.stringify({ clinicaId }),
  });
}

export async function listRecados({ clinicaId, box = 'all', status, q, page = 1, limit = 50 }) {
  const params = new URLSearchParams();
  params.set('clinicaId', clinicaId);
  params.set('box', box);
  if (status) params.set('status', status);
  if (q) params.set('q', q);
  params.set('page', String(page));
  params.set('limit', String(limit));
  return request(`api/recados?${params.toString()}`, { method: 'GET' });
}

export async function createRecado(payload) {
  return request('api/recados', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateRecado(id, patch) {
  return request(`api/recados/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}

export async function deleteRecado(id, reason) {
  return request(`api/recados/${id}`, {
    method: 'DELETE',
    body: JSON.stringify({ reason }),
  });
}

export async function responderRecado(id, resposta) {
  return request(`api/recados/${id}/resposta`, {
    method: 'POST',
    body: JSON.stringify({ resposta }),
  });
}
